export const EXPIRED_SECOND = 240 * 60 * 60
